"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const PaymentWidgetMixin_1 = require("@/client/mixins/PaymentWidgetMixin");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'PaymentUnitComponent',
    props: {
        modelValue: {
            type: Number,
            required: true,
        },
        unit: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        showMax: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    methods: {
        ...PaymentWidgetMixin_1.PaymentWidgetMixin.methods,
    },
    computed: {
        iconClass() {
            switch (this.unit) {
                case 'kuiperAsteroids': return 'resource_icon--asteroid';
                case 'lunaArchivesScience': return 'resource_icon--science';
                case 'spireScience': return 'resource_icon--science';
                case 'auroraiData': return 'resource_icon--auroraidata';
                case 'seeds': return 'resource_icon--seed';
                default: return 'resource_icon--' + this.unit;
            }
        },
    },
});
